import { questionInputType, assignmentType } from '@/api/assignment-question'
import { deleteQuestionById } from '@/api/question-bank'

export const questionMixin = {
  data () {
    return {
      subjectDisabled: false,
      subject_id: null, //selected question_bank
      questionbank_type: 1, //exams, homework, report, question bank
      assignment_header_info: {
        question_section_title: '',
        question_section_description: ''
      },
      delete_id: [], //question bank
      assignment_list: [],

      //temporary
      questionbank_type_array: [
        {
          assignmnent_type: 'Question & Answer',
          assignment_id: 1,
          platform_module_id: 43
        },
        {
          assignmnent_type: 'Homework',
          assignment_id: 2,
          platform_module_id: 13
        },
        {
          assignmnent_type: 'Report',
          assignment_id: 3,
          platform_module_id: 12
        },
        {
          assignmnent_type: 'Exam',
          assignment_id: 4,
          platform_module_id: 17
        }
      ],

      //temporary

      input_field_type: [], //for question input type
      //question details

      question_details: [
        {
          id: null,
          input_type_id_obj: '',
          input_type_id: '',
          question_title: '',
          answer: '',
          answerfeedback: '',
          option: [],
          point: 0,
          showAnswer: false,
          ordering: '',
          save_question_bank: false,
          file_id: [],
          links: [''],
          platform_module_id: '',
          tag_ids: [],
          filesInfo: [],
          showFileUpload: false,
          showLinkUpload: false,
          acceptedfileUploadType: 'image/*',
          fileUploadHelpText: 'Choose Image files'

          //only if it is selection,checkbox
        }
      ]
    }
  },
  methods: {
    setInitDefaultArray () {
      this.questionbank_type = 1 //exams, homework, report, question bank
      this.question_section_title = '' //selected section_title
      this.question_section_description = '' //selected section_description
      this.question_details = [
        {
          input_type_id_obj: '',
          input_type_id: '',
          question_title: '',
          answer: '',
          answerfeedback: '',
          option: [],
          point: 0,
          showAnswer: false,
          ordering: '',
          save_question_bank: false,
          file_id: [],
          links: [''],
          filesInfo: [],
          showFileUpload: false,
          showLinkUpload: false,
          acceptedfileUploadType: 'image/*',
          fileUploadHelpText: 'Choose Image files'
        }
      ]
    },
    async fetchQuestionInputType () {
      try {
        const { data } = await questionInputType()
        this.input_field_type = data.data

      } catch (error) {
        console.log(error)
      }
    },
    async fetchAssignmentTypes () {
      try {
        const { data } = await assignmentType()

        //
        this.assignment_list = data.data

        if (this.assignment_id_to_edit && this.platform_module_id !== 43) {
          this.fetchTag(this.platform_module_id)

        } else {
          this.fetchTag(this.platform_module_id)
        }
      } catch (error) {
        console.log(error)
      }
    },
    openConfirm (id) {
      this.delete_id.length = 0
      this.delete_id[0] = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are You Sure You want to deleted this Question?',
        accept: this.acceptAlert
      })
    },

    acceptAlert () {
      this.questionDelete(this.delete_id)
    },
    async questionDelete () {


      try {
        const customerId = this.$store.getters.customerId
        const payload = {
          ids: this.delete_id
        }
        const data = await deleteQuestionById(customerId, payload)
        console.log(data)

        // const deleteIndex = this.question_details.findIndex(element => element.id === id)

        // this.question_details.splice(deleteIndex, 1)

        this.$vs.notify({
          title: 'Success',
          text: 'Question is deleted from the question bank',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        for (const delete_id of this.delete_id) {
          for (let i = 0; i < this.question_details.length; i++) {
            //
            if (delete_id === this.question_details[i].id) {
              this.question_details.splice(i, 1)
              // break
            }
          }
        }

        this.$router.push({ name: 'QuestionsBankList' })
      } catch (e) {
        console.log(e)
      }
    },
    setQuestionDetails (array) {
      return array.map(each_question => {
        return {
          id: each_question.id,
          files: each_question.files ? each_question.files : [],
          filesInfo: each_question.files,
          file_id: [],
          links:
            each_question.links.length > 0
              ? each_question.links.map(url => {
                return url.url
              })
              : [''],
          input_type_id_obj: {
            id: each_question.question_input_type.id,
            label: each_question.question_input_type.label,
            field_type: each_question.question_input_type.field_type
          },
          input_type_id: each_question.question_input_type_id,
          question_title: each_question.title,
          answer: each_question.short_answer,
          answerfeedback: each_question.feedback,
          marks: 10000,
          option: each_question.questions_options,
          point: each_question.point,
          showAnswer: false,
          ordering: each_question.ordering,
          showFileUpload: false,
          showLinkUpload: false,
          acceptedfileUploadType: 'image/*',
          fileUploadHelpText: 'Choose Image files'
        }
      })
    },
    checkingOptionAnswerDone () {
      if (this.assignment_type === 3 || this.assignment_type === 'Report' || this.assignment_type === '3') {
        return true
      }
      let validMcqAnswer = true

      const countNoOfOption = []
      const countingAnswerGiven = []

      this.question_details
        .filter(eachQuestion => {
          if (
            ['radio', 'checkbox', 'select', 'multiselect'].includes(
              eachQuestion.input_type_id_obj.field_type
            )
          ) {
            return eachQuestion
          }
        })
        .forEach((ele, index) => {
          countNoOfOption.push(index)
          ele.option.forEach(optionEle => {
            if (optionEle.is_answer) {
              countingAnswerGiven.push(index)
            }
          })
        })


      const uniqueCountAnswer = [...new Set(countingAnswerGiven)]
      if (countNoOfOption.length === uniqueCountAnswer.length) {
        validMcqAnswer = true
      } else {
        validMcqAnswer = false
      }

      return validMcqAnswer
    }
  },
  computed: {
    getFormName () {
      if (this.assignment_type === 'Q&A' || this.assignment_type === '1') {
        return 'Question & Answer'
      } else if (
        this.assignment_type === 'Homework' ||
        this.assignment_type === '2' ||
        this.assignment_type === 'Home Work'
      ) {
        return 'Homework'
      } else if (
        this.assignment_type === 'Report' ||
        this.assignment_type === '3'
      ) {
        return 'Report'
      } else if (
        this.assignment_type === 'Exam' ||
        this.assignment_type === '4'
      ) {
        return 'Exam'
      }
    }
    /* chekingInputMultipleSelect(){

    } */
  }
}
